import { AxiosPublic } from "../config/axios";

export async function getPaintings(query) {
  return await AxiosPublic.get("painting", { params: { ...query } })
    .then(res => res.data.data)
    .catch(err => { alert(err.response?.data.message); return null })
}
export async function getLandingPaintings() {
  return await AxiosPublic.get("painting/landing")
    .then(res => res.data.data)
    .catch(err => { alert(err.response?.data.message); return null })
}
export async function getOnePainting(id) {
  return await AxiosPublic.get("painting/show/" + id)
    .then(res => res.data.data)
    .catch(err => { alert(err.response?.data.message); return null })
}
export async function getPaintingPrice(id, frameId, width, height, passpartout) {
  return await AxiosPublic.get("painting/calculate-price/" + id + (frameId ? `/${frameId}` : ''), { params: { width, height, passpartout } })
    .then(res => res.data.data)
    .catch(err => { alert(err.response?.data.message); return { error: true } })
}
export async function getOnePaintingComments(id) {
  return await AxiosPublic.get("painting/comments/" + id)
    .then(res => res.data.data)
    .catch(err => { alert(err.response?.data.message); return null })
}
export async function PaintingSearch(text) {
  return await AxiosPublic.get("painting/search?search_word=" + text)
    .then(res => res.data.data)
    .catch(err => { alert(err.response?.data.message); return null })
}
